import { Info } from "lucide-react";

/**
 * Terminal toast shown when a document attaches but AI extraction returns no
 * usable fields. Content-agnostic — must read correctly for any section type.
 * Single source shared by every completion path: the category-page expandable
 * row upload, the out-of-band phone upload (SSE), and the guided wizard.
 *
 * Visibility detail (session-61 polish): a sage Info icon + a sage left-accent
 * on THIS toast only (per-call className + a ReactNode description) — no change
 * to the shared toast component, so no other toast is affected. The icon lives
 * in the description, not the title: the toast's `title` is typed
 * `string & ReactNode` (ToastProps spreads the DOM title attribute), so it must
 * stay a string; `description` is plain ReactNode and accepts the icon.
 */
export const NO_EXTRACTION_TOAST = {
  title: "No details found to extract",
  description: (
    <span className="flex items-center gap-2">
      <Info className="h-4 w-4 shrink-0 text-sage-600" />
      The document has been attached.
    </span>
  ),
  className: "border-l-4 border-l-sage-600",
};
